export default __webpack_public_path__ + "static/pokitpal-casestudy-a385a7ddd2dfeb2293fc3d65099afd42.jpg";